// stat block directive
//
//   <stat-block label="Stat Name" value="123" />

let module = angular.module('app.directives');

module.directive('statBlock', () => {
  'ngInject';

  return {
    restrict: 'E',
    scope: { label: '=', value: '=', format: '@', size: '@' },
    template: `
      <div class="stat-block {{size}}"
           ng-class="{
              'col-xs-12': size == 'full' || !size,
              'col-xs-6': size == 'half-l' || size == 'half-r'
           }">
        <h2 ng-if="format === undefined || format == 'number'">
          <span fittext>
            {{value | number}}
          </span>
        </h2>
        <h2 ng-if="format == 'currency'" class="text-center">
          <span fittext>
            \${{value | number:2}}
          </span>
        </h2>
        <h2 ng-if="format == 'hours'" class="text-center">
          <span fittext>
            {{value | number:1}}
          </span>
        </h2>

        <h5 class="text-center overflow-ellipse">{{label}}</h5>
      </div>
    `,
  };
});



// WEBPACK FOOTER //
// ./app/directives/stat-block.js